// pages/Contact.js
import React from "react";
const bgImg = "/images/1.jpeg";

function Contact() {
  const [loading, setLoading] = React.useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    const form = e.target;
    const name = form[0].value;
    const email = form[1].value;
    const phone = form[2].value;
    const vehicle = form[3].value;
    const message = form[4].value;
    try {
      const apiUrl = "https://api.capital-businessgroup.com/api/contact";

      const res = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, phone, vehicle, message }),
      });
      if (res.ok) {
        alert("✅ Message sent!");
        form.reset();
      } else {
        const err = await res.json();
        alert("❌ Failed: " + (err.error || "Unknown error"));
      }
    } catch (err) {
      alert("⚠️ Error sending message. Please try again later.");
      console.error("Contact form error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-bg contact-bg-img">
      <style>{`
        .contact-bg-img {
          position: relative;
          background: url(${bgImg}) center/cover no-repeat;
          background-attachment: fixed;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
        .contact-bg-img::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          width: 100%;
          height: 100%;
          background: rgba(10, 20, 40, 0.85);
          z-index: 1;
        }
        .contact-bg-img > * {
          position: relative;
          z-index: 2;
        }
        .contact-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(10, 10, 30, 0.55);
          z-index: 1;
        }
        .contact-title {
          color: #fff;
          text-shadow: 0 2px 16px rgba(10,61,98,0.18);
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 32px;
          text-align: center;
          margin-top: 48px;
        }
        .contact-main {
          display: flex;
          flex-direction: row;
          gap: 48px;
          max-width: 1100px;
          margin: 0 auto 48px auto;
          justify-content: center;
          align-items: stretch;
          width: 95%;
        }
        .contact-form {
          background: #f8fcff;
          border-radius: 24px;
          padding: 40px;
          box-shadow: 0 8px 32px rgba(25,118,210,0.12);
          display: flex;
          flex-direction: column;
          gap: 28px;
          flex: 1;
          min-width: 340px;
          max-width: 520px;
          align-items: center;
          border: 1px solid #e3eaf5;
          min-height: 420px;
        }
        .form-title {
          font-size: 1.5rem;
          font-weight: bold;
          color: #E67E22;
          margin-bottom: 16px;
          text-align: center;
        }
        .form-input {
          border: 1px solid #636E72;
          border-radius: 10px;
          padding: 16px;
          font-size: 1.15rem;
          width: 100%;
          margin-bottom: 8px;
        }
        .btn.btn-primary {
          background: #E67E22;
          color: #fff;
          font-size: 1.15rem;
          padding: 16px 40px;
          border-radius: 10px;
          font-weight: 600;
          border: none;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(230,126,34,0.12);
          transition: background 0.2s;
        }
        .btn.btn-primary:hover {
          background: #d35400;
        }
        @media (max-width: 900px) {
          .contact-main {
            flex-direction: column;
            align-items: center;
            max-width: 98vw;
          }
          .contact-form {
            min-width: 260px;
            max-width: 98vw;
          }
        }
      `}</style>

      <div className="contact-overlay"></div>
      <h1 className="contact-title">Contact / Book Service</h1>
      <div className="contact-main" style={{ position: 'relative' }}>
        {/* Booking Form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2 className="form-title">Book a Service</h2>
          <input type="text" placeholder="Name" className="form-input" required disabled={loading} />
          <input type="email" placeholder="Email" className="form-input" required disabled={loading} />
          <input type="tel" placeholder="Phone" className="form-input" required disabled={loading} />
          <input type="text" placeholder="Vehicle Details" className="form-input" required disabled={loading} />
          <textarea placeholder="Service Request" className="form-input" rows={3} required disabled={loading} />
          <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? "Sending..." : "Submit"}</button>
        </form>
        {loading && (
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            borderRadius: 24
          }}>
            <div style={{
              padding: 32,
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 2px 16px rgba(25,118,210,0.10)',
              fontSize: 20,
              color: '#E67E22',
              fontWeight: 600
            }}>
              Sending your message...
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Contact;
